export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65'),
	() => import('./nodes/66'),
	() => import('./nodes/67'),
	() => import('./nodes/68'),
	() => import('./nodes/69'),
	() => import('./nodes/70'),
	() => import('./nodes/71'),
	() => import('./nodes/72'),
	() => import('./nodes/73'),
	() => import('./nodes/74'),
	() => import('./nodes/75'),
	() => import('./nodes/76'),
	() => import('./nodes/77'),
	() => import('./nodes/78'),
	() => import('./nodes/79'),
	() => import('./nodes/80'),
	() => import('./nodes/81'),
	() => import('./nodes/82')
];

export const server_loads = [];

export const dictionary = {
		"/(app)": [12,[2]],
		"/admin": [62,[11]],
		"/admin/evaluations": [63,[11]],
		"/admin/evaluations/[tab]": [64,[11]],
		"/admin/functions": [65,[11]],
		"/admin/functions/create": [66,[11]],
		"/admin/functions/edit": [67,[11]],
		"/admin/settings": [68,[11]],
		"/admin/settings/[tab]": [69,[11]],
		"/admin/users": [70,[11]],
		"/admin/users/[tab]": [71,[11]],
		"/auth": [72],
		"/auth/admin": [73],
		"/(app)/channels/[id]": [14,[2]],
		"/(app)/contact": [15,[2]],
		"/(app)/credit-usage": [16,[2]],
		"/(app)/c/[id]": [13,[2]],
		"/(app)/document": [17,[2]],
		"/(app)/document/[id]": [18,[2]],
		"/error": [74],
		"/feature": [75],
		"/(app)/home": [19,[2,3]],
		"/(app)/image-chat": [20,[2]],
		"/(app)/image-chat/create": [21,[2]],
		"/(app)/notes": [22,[2,4]],
		"/(app)/notes/[id]": [23,[2,4]],
		"/notice": [76],
		"/notice/[id]": [77],
		"/(app)/page": [24,[2,5]],
		"/payment": [79],
		"/pay": [78],
		"/(app)/playground": [25,[2,6]],
		"/(app)/playground/completions": [26,[2,6]],
		"/policy/privacy": [80],
		"/(app)/project/[projectId]": [27,[2]],
		"/(app)/project/[projectId]/c/[id]": [28,[2]],
		"/(app)/slide": [29,[2]],
		"/(app)/slide/[id]": [30,[2]],
		"/s/[id]": [81],
		"/(app)/usage": [31,[2,7]],
		"/(app)/usage/date-summary": [32,[2,7]],
		"/(app)/usage/model-summary": [33,[2,7]],
		"/(app)/usage/summary": [34,[2,7]],
		"/(app)/usage/used": [35,[2,7]],
		"/(app)/video": [36,[2,8]],
		"/(app)/video/[id]": [37,[2,8]],
		"/watch": [82],
		"/(app)/workspace": [38,[2,9]],
		"/(app)/workspace/functions/create": [39,[2,9]],
		"/(app)/workspace/gpt": [40,[2,9,10]],
		"/(app)/workspace/gpt/create": [41,[2,9,10]],
		"/(app)/workspace/gpt/edit": [42,[2,9,10]],
		"/(app)/workspace/gpt/likelist": [43,[2,9,10]],
		"/(app)/workspace/gpt/mylist": [44,[2,9,10]],
		"/(app)/workspace/knowledge": [45,[2,9]],
		"/(app)/workspace/knowledge/create": [47,[2,9]],
		"/(app)/workspace/knowledge/[id]": [46,[2,9]],
		"/(app)/workspace/models": [48,[2,9]],
		"/(app)/workspace/models/create": [49,[2,9]],
		"/(app)/workspace/models/edit": [50,[2,9]],
		"/(app)/workspace/ocr": [51,[2,9]],
		"/(app)/workspace/prompts_back1": [55,[2,9]],
		"/(app)/workspace/prompts_back1/create": [57,[2,9]],
		"/(app)/workspace/prompts_back1/edit": [58,[2,9]],
		"/(app)/workspace/prompts_back1/[tab]": [56,[2,9]],
		"/(app)/workspace/prompts": [52,[2,9]],
		"/(app)/workspace/prompts/create": [53,[2,9]],
		"/(app)/workspace/prompts/edit": [54,[2,9]],
		"/(app)/workspace/tools": [59,[2,9]],
		"/(app)/workspace/tools/create": [60,[2,9]],
		"/(app)/workspace/tools/edit": [61,[2,9]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.svelte';